import Sticky from 'sticky-js'

class Adhesion {
  constructor () {
    this.stickyAdhesion = null
  }

  init () {
    const btnEmail = $('.btn-email')

    btnEmail.on('click', (e) => {
      e.preventDefault()
      $('.email').removeClass('hidden')
      $('.btn-email').addClass('hidden')
    })

    this.handleResize()
    $(window).on('resize', () => this.handleResize())
  }

  handleResize () {
    const windowWidth = $(window).width()

    if (windowWidth >= 1024) {
      if (!this.stickyAdhesion) {
        this.stickyAdhesion = new Sticky('.sticky-adhesion')
      }
    } else {
      if (this.stickyAdhesion) {
        this.stickyAdhesion.destroy()
        this.stickyAdhesion = null
      }
    }
  }
}

export default Adhesion
